/* ==========================================================================
   VAN LYNN — quick-view.js
   Opens the quick view dialog and loads sections/quick-view.liquid for the
   chosen product via the Section Rendering API.
   ========================================================================== */
(function () {
  'use strict';
  const VL = (window.VL = window.VL || {});
  const cache = new Map();

  async function load(url) {
    const clean = url.split('?')[0];
    if (cache.has(clean)) return cache.get(clean);
    const res = await fetch(`${clean}?section_id=quick-view`);
    if (!res.ok) throw new Error(res.status);
    const html = VL.parseHTML(await res.text()).querySelector('.quick-view__product');
    const markup = html ? html.outerHTML : '';
    cache.set(clean, markup);
    return markup;
  }

  document.addEventListener('click', async (e) => {
    const trigger = e.target.closest('[data-quick-view]');
    if (!trigger) return;
    const modal = document.getElementById('QuickView');
    if (!modal) return;
    e.preventDefault();
    const content = modal.querySelector('[data-quick-view-content]');
    trigger.classList.add('is-loading');
    try {
      const markup = await load(trigger.dataset.quickView);
      if (!markup) throw new Error('empty');
      content.innerHTML = markup;
      modal.open(trigger);
      document.dispatchEvent(new CustomEvent('vl:content-loaded', { detail: { root: content } }));
    } catch (err) {
      window.location.href = trigger.dataset.quickView;
    } finally {
      trigger.classList.remove('is-loading');
    }
  });
})();
